import React from "react";

const VerticalForm = ({ defaultValues, children, onSubmit, formClass }) => {
  return (
    <form onSubmit={onSubmit} className={formClass} noValidate>
      {Array.isArray(children)
        ? children.map((child) =>
            child.props && child.props.name
              ? React.createElement(child.type, {
                  ...child.props,
                  key: child.props.name,
                })
              : child
          )
        : children}
    </form>
  );
};

export default VerticalForm;
